import { render, staticRenderFns } from "./health-hacks.vue?vue&type=template&id=2318414b&"
import script from "./health-hacks.vue?vue&type=script&lang=js&"
export * from "./health-hacks.vue?vue&type=script&lang=js&"
import style0 from "./health-hacks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports